import { computed, Injectable, signal } from '@angular/core';
import {
  WORKPAPER_OPERATION_MESSAGES,
  WorkpaperOperationKind,
} from 'src/app/constants/workbook.constants';

export interface WorkpaperOperationInfo {
  kind: WorkpaperOperationKind;
  label: string;
  ownerId?: string;
}

@Injectable({ providedIn: 'root' })
export class WorkpaperOperationLockService {
  readonly activeOperation = signal<WorkpaperOperationInfo | null>(null);
  readonly isOperationInProgress = computed(() => this.activeOperation() !== null);

  async runExclusive<T>(
    operation: WorkpaperOperationInfo,
    action: () => Promise<T>
  ): Promise<T> {
    if (this.activeOperation()) {
      throw new Error(WORKPAPER_OPERATION_MESSAGES.OperationInProgress);
    }

    this.activeOperation.set(operation);

    try {
      return await action();
    } finally {
      this.activeOperation.set(null);
    }
  }
}